import React, { useEffect, useState } from "react";
import { navigate } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import EmotionCard from "../../molecules/emotion-card/emotionCard";
import Button from "../../atoms/button/button";

import "./emotions.scss";
import { generateRandomNumber } from "../../../utils/generalUtilities";

const Emotions = (props: ReferenciaContenido) => {
  const [emotionsToShow, setEmotionsToShow] = useState<Array<any>>([]);

  useEffect(() => {
    props.referenciaPlantillaContenido.filter(emotion => emotion.titulo).length > 6 ? 
      shuffleArray() : setEmotionsToShow(props.referenciaPlantillaContenido);
  }, [props]);

  const makeSearch = async (emotionName: string, emotion: string) => {
    document.body.style.cursor = "wait";
    document.body.style.cursor = "default";
    navigate(`/ver-todo/?title=Libros para que te sientas ${emotionName.toLowerCase()}` +
    `&searchType=recommender` +
    `&contentType=Libros` + 
    `&searchParam=emotion` +
    `&paramValues=${emotion}`,
     {
      state: {
        infoArray: []
      },
    });
  };

  const shuffleArray = () => {
    const { referenciaPlantillaContenido } = props;
    const shuffledArray = [...referenciaPlantillaContenido.filter(emotion => emotion.titulo)];
  
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const randomIndex = generateRandomNumber(i + 1);
      [shuffledArray[i], shuffledArray[randomIndex]] = [shuffledArray[randomIndex], shuffledArray[i]];
    }
  
    const truncatedArray = shuffledArray.slice(0, 6);
  
    document.getElementById("o-emotions__slider").scrollLeft = 0;
    setEmotionsToShow(truncatedArray);
  };

  return (
    <div className="o-emotions">
      <h2 className="o-emotions__title title-secondary">
        {props.tituloGeneral}
      </h2>
      <p className="o-emotions__description">
        {props.descripcion.json.content[0].content[0].value}
      </p>
      <ul className="o-emotions__slider" id="o-emotions__slider">
        {emotionsToShow.map((emotion, index) => (
          <li
            key={index}
            className={`o-emotions__slider__item
              gtm${normalizeTwoWords(props.nombreCategoria)}ComoTeSientesHoy${normalizeTwoWords(emotion.tituloBanner)}`}
            onClick={() => makeSearch(emotion.tituloBanner, emotion.tipoTitulo)}
          >
            <EmotionCard
              imageSrc={emotion.imagenPrincipal[0].file.url}
              tituloBanner={emotion.tituloBanner}
              gtmClass={`gtm${normalizeTwoWords(props.nombreCategoria)}ComoTeSientesHoy${normalizeTwoWords(emotion.tituloBanner)}`}
            />
          </li>
        ))}
        {props.referenciaPlantillaContenido.length > 6 &&
          <li className="o-emotions__shuffle">
            <button 
              type="button"
              disabled={false}
              onClick={() => shuffleArray()}
            >
              {props.tituloBoton}
            </button>
          </li>
        }
      </ul>
      {props.referenciaPlantillaContenido.length > 6 &&
        <div className="o-emotions__shuffle o-emotions__shuffle__desktop">
          <Button 
            type="button"
            classname="primary"
            text={props.tituloBoton}
            isDisabled={false}
            onClickAction={() => shuffleArray()}
            gtmMark={`gtm${normalizeTwoWords(props.nombreCategoria)}ComoTeSientesHoy${normalizeTwoWords(props.tituloBoton)}`}
          />
        </div>
      }
    </div>
  );
};

export default Emotions;
